import {toast as reactToast, ToastOptions} from 'react-semantic-toasts';
import HTMLReactParser from 'html-react-parser';
import 'react-semantic-toasts/styles/react-semantic-alert.css';
import './react.Toasts.scss';
import {isOnline} from '../../lib/hooks/useOnlineStatus';
import {isArray} from '../../lib/helpers/isArray';

// cast: the lib types title as required, but it is optional at runtime
const defaults = {
  animation: 'drop',
  time: 5000,
} as ToastOptions;

export const warningToast = (msg: string): void =>
  reactToast({
    type: 'warning',
    icon: 'exclamation',
    description: HTMLReactParser(msg) as string,
    ...defaults,
  });

export const successToast = (msg: string, settings: Partial<ToastOptions> = {}): void =>
  reactToast({
    type: 'success',
    icon: 'check',
    description: HTMLReactParser(msg) as string,
    ...defaults,
    ...settings,
  });

export const errorToast = (msg: string | string[]): void => {
  if (isArray(msg)) {
    msg = msg.join('<br/>');
  }

  reactToast({
    type: 'warning',
    description: HTMLReactParser(msg) as string,
    icon: 'cancel',
    ...defaults,
  });
};

export const infoToast = (msg: string): void =>
  reactToast({
    type: 'info',
    description: HTMLReactParser(msg) as string,
    ...defaults,
  });

export const toast = (options: ToastOptions): void => reactToast(options);

export const requestErrorToast = (msg: string): false | void =>
  isOnline() &&
  reactToast({
    type: 'warning',
    description: HTMLReactParser(msg) as string,
    icon: 'warning sign',
    ...defaults,
  });
